<template>
  <div>
    <div class="grop-news" v-if="terminal == 'PC'">
      <div class="top-menu">
        <div class="top-menu-left">
          <span class="top-menu-left-span1">{{$t("head.head-10")}} ></span> <span class="top-menu-left-span2" @click="type='list'">{{$t("head.head-14")}}</span> 
        </div>
        <div class="top-menu-right" v-if="dialog">
          <div class="year-select" style="width: 140px;">
            <el-select v-model="selecttype"  @change="changeSelect" >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </div>
          <div class="search-input">
            <el-input
              :placeholder='$t("home.home-2")'
              v-model="value" @keyup.enter.native="toSearch" clearable @clear="toSearch">
              <i slot="suffix" @click="toSearch" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
      </div>
      <div v-if="!dialog">
        <div class="journal-tab">
          <p class="journal-tab-inner" :class="{'journal-active': tab == 1}" @click="changeTab(1)">{{$t("home.home-3")}}</p>
          <p class="journal-tab-inner" :class="{'journal-active': tab == 2}" @click="changeTab(2)">{{$t("home.home-4")}}</p>
        </div>
        <div class="journal-content">
          <div class="journal-content-icon-box">
            <img @click="switchBtnPre" class="journal-content-icon" src="../../../assets/img/left.png" alt="">
          </div>
          <div class="journal-content-swiper">
            <el-carousel ref="carouselRef" :interval="3000" indicator-position="outside" arrow="never" height="480px" :autoplay="false" >
              <el-carousel-item v-for="(item,index) in imgList" :key="index" >
                <div class="journal-content-inner">
                  <div class="journal-content-box" v-for="(innerItem,innerIndex) in item" :key="innerIndex">
                    <img class="journal-content-img" @click="toDetail(innerItem)"  :src="imgBaseUrl + innerItem.ImgUrl" alt="">
                  </div>
                  <div class="journal-content-box" @click="dialog = true" v-if="index == 1 && list.length >= 5">
                    <img class="journal-content-img" src="../../../assets/img/more-jounery.png" alt="">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>  
          </div>
          <div class="journal-content-icon-box">
            <img @click="switchBtnNext" class="journal-content-icon" src="../../../assets/img/right.png" alt="">
          </div>
        </div>
      </div>
      <div v-if="dialog" >
          <div class="journal-box">
            <div class="journal-inner" @click="toDetail(item)" v-for="(item,index) in list" :key="index">
              <img class="journal-img" :src="imgBaseUrl + item.ImgUrl" alt="">
              <p class="journal-p">{{ item.Title }}</p>
            </div>
          </div>
        </div>
    </div>

    <div style="width: 100%;padding: 20px 0;" v-if="terminal == 'Mobile'">
      <div v-if="!dialog">
        <div class="journal-tab" style="width: 100vw;">
          <p class="journal-tab-inner" style="width: 150px;height: 25px;line-height: 25px;font-size: 11px;" :class="{'journal-active': tab == 1}" @click="changeTab(1)">{{$t("home.home-3")}}</p>
          <p class="journal-tab-inner" style="width: 150px;height: 25px;line-height: 25px;font-size: 11px;" :class="{'journal-active': tab == 2}" @click="changeTab(2)">{{$t("home.home-4")}}</p>
        </div>
        <div class="journal-content" style="width: 100%">
          <div class="journal-content-swiper" style="width: 100vw;">
            <el-carousel ref="carouselRef" :interval="3000" indicator-position="none" arrow="never" height="200px" :autoplay="false" >
              <el-carousel-item v-for="(item,index) in imgList" :key="index" >
                <div class="journal-content-inner" style="width: 100vw;">
                  <div class="journal-content-box" style="width: 32.3%;margin-right: 1%;border:none" v-for="(innerItem,innerIndex) in item" :key="innerIndex">
                    <img class="journal-content-imgM" style="width: 100%;" @click="toDetail(innerItem)"  :src="imgBaseUrl + innerItem.ImgUrl" alt="">
                  </div>
                  <div class="journal-content-box" style="width: 32.3%;margin-right: 1%;;border:none" @click="dialog = true" v-if="index == 1 && list.length >= 5">
                    <img class="journal-content-imgM" style="width: 100%;" src="../../../assets/img/more-jounery.png" alt="">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>  
          </div>
        </div>
        <div class="change-box">
          <div class="journal-content-icon-box">
            <img style="width: 30px;height: 30px;" @click="switchBtnPre" class="journal-content-icon" src="../../../assets/img/left.png" alt="">
          </div>
          <div class="journal-content-icon-box">
            <img style="width: 30px;height: 30px;" @click="switchBtnNext" class="journal-content-icon" src="../../../assets/img/right.png" alt="">
          </div>
        </div>
      </div>
      <div v-if="dialog" >
          <div class="mobile-journal-box">
            <p class="mobile-go-back" style="margin-top: 0;margin-bottom: 15px;" @click="Goback()">  《 {{$t("home.home-19")}}</p>
            <div class="mobile-journal-inner" @click="toDetail(item)" v-for="(item,index) in list" :key="index">
              <img class="mobile-journal-img" :src="imgBaseUrl + item.ImgUrl" alt="">
              <p class="mobile-journal-p">{{ item.Title }}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
  
</template>

<script>
import newsDetail from './newsDetail.vue'
export default {
  name: 'HomeView',
  components: {
    newsDetail
  },
  data(){
    return{
      type: 'list',
      dialog: false,
      tab: 1,
      list2: [],
      list: [],
      list1: [],
      typeList: [
     
      ],
      selecttype: 1,
      imgList: [],
      currentIndex: 0,


      tabType: 0,
      currentType: '',
      currentPage: 1,
      imgBaseUrl: '',
      id: '',
      value: '',
      terminal: 'PC',
    }
  },
  mounted(){
    this.terminal = localStorage.getItem('terminal')
    this.imgBaseUrl = localStorage.getItem('imgBaseUrl')
    this.getList()
    this.typeList.push({value:1,label:this.$t("home.home-3")})
    this.typeList.push({value:2,label:this.$t("home.home-4")})
  },
  methods:{
    Goback(){
      this.dialog = false;
      this.switchBtnPre();
    },
   switchBtnPre(){
      if(this.currentIndex == 0){
        // this.$message({
        //   showClose: true,
        //   type: 'warning',
        //   message: '已是第一页'
        // });
        this.currentIndex = this.imgList.length - 1
        this.$refs.carouselRef.setActiveItem(this.currentIndex)
      }else{
        this.currentIndex--
        this.$refs.carouselRef.setActiveItem(this.currentIndex)
      }
    },
    switchBtnNext(){
      if(this.currentIndex == this.imgList.length - 1){
        this.currentIndex = 0
        this.$refs.carouselRef.setActiveItem(this.currentIndex)
      }else{
        this.currentIndex++
        this.$refs.carouselRef.setActiveItem(this.currentIndex)
      }
    },
    changeSelect(e){
      this.currentIndex = 0
       this.tab = e
       this.selecttype=e
      if(e == 1){
        this.getList()
      }else if(e == 2){
        this.getList2()
      }
    },
    changeTab(index){
      this.currentIndex = 0
      this.tab = index
      this.selecttype=index
      if(index == 1){
        this.getList()
      }else if(index == 2){
        this.getList2()
      }
    },
    toSearch(){
      this.type = 'list'
      if(this.tab == 1){
        this.getList()
      }else if(this.tab == 2){
        this.getList2()
      }
    },
    toDetail(item){


if(item.PageNumber&&item.PageNumber>0){
  const{ href } = this.$router.resolve({name:"photo"});
  window.open(href+'?type='+this.selecttype+'&&id='+item.ID,'_blank');
}else{
    let url = this.imgBaseUrl + item.PdfUrl
    window.open(url,'_blank')
}



    },
    getList(){
      let that = this
      let params = {
        page: this.currentPage,
        rows: 200,
        para: that.value,
        Language: localStorage.getItem('Language') || 1
      }
      that.imgList = []
      that.$axios.post(this.baseURL + "api/PX_FuShouBao/GetPageDataV1",params).then(
        (res) => {
          that.list = res.data.rows
          let list1 = [...that.list]
          if(list1.length > 5){
            list1 = list1.splice(0,5)
          }
          for(let i = 0, len = list1.length ; i < len; i += 3) {
            that.imgList.push(list1.slice(i, i + 3))
          }
        },
        (error) => {
          console.log("请求失败了", error.message);
      });
    },
    getList2(){
      let that = this
      let params = {
        page: this.currentPage,
        rows: 200,
        para: that.value,
        Language: localStorage.getItem('Language') || 1
      }
      that.imgList = []
      that.$axios.post(this.baseURL + "api/PX_FuShouHumanity/GetPageDataV1",params).then(
        (res) => {
          that.list = res.data.rows
          let list1 = [...that.list]
          if(list1.length > 5){
            list1.length = 5
          }
          for(let i = 0, len = list1.length; i < len; i += 3) {
            that.imgList.push(list1.slice(i, i + 3))
          }
        },
        (error) => {
          console.log("请求失败了", error.message);
      });
    }
  }
}
</script>

<style lang="scss">
.grop-news{
  min-height: 500px;
 
}
.journal-content-swiper{
  .el-carousel__indicator--horizontal 
  { 
  padding-top: 40px;
  }
  .el-carousel__indicators--outside button {
    background-color:#E9B454;
      height: 4px;
  }
}
</style>